/* eslint-disable */
import React, { useState, useEffect } from "react";

import { useTranslation } from "../../locale/useTranslation";
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, STORAGE_DESTINATION, TOAST_TYPES } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import BossDialog from "../../components/BossDialog";
import ReactGA from "react-ga4";

// MUI Imports
import {
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Checkbox,
    FormControlLabel,
    Button,
    Box,
    Paper,
    InputAdornment,
    Alert,
    Stack,
    Divider,
    Typography,
    Popper
} from "@mui/material";

import {
    Cloud as CloudIcon,
    CloudDownload as CloudDownloadIcon,
    FolderShared as FolderSharedIcon,
    Shuffle as ShuffleIcon,
    Dns as DnsIcon,
    Storage as StorageIcon,
    Mail as MailIcon
} from "@mui/icons-material";
import { EditPageHeader } from "../../components/EditPageHeader";
import ToastNotification from "../../components/ToastNotification";
import InfoRoundButton from "../../components/InfoRoundButton";

const PublishProviderEditForm = (props) => {
    const lang = useTranslation();

    const getCredentialData = () => {
        switch (props?.item?.StorageDestination) {
            case STORAGE_DESTINATION.Cloudinary:
                return {
                    cloud_name: props?.item?.StorageCredentials?.Cloudinary?.cloud_name ?? "",
                    api_key: props?.item?.StorageCredentials?.Cloudinary?.api_key ?? "",
                    api_secret: props?.item?.StorageCredentials?.Cloudinary?.api_secret ?? "",
                    preset: props?.item?.StorageCredentials?.Cloudinary?.preset ?? "",
                }
            case STORAGE_DESTINATION.S3:
                return {
                    accessKeyId: props?.item?.StorageCredentials?.S3?.accessKeyId ?? "",
                    secretAccessKey: props?.item?.StorageCredentials?.S3?.secretAccessKey ?? "",
                    region: props?.item?.StorageCredentials?.S3?.region ?? "",
                    bucketName: props?.item?.StorageCredentials?.S3?.bucketName ?? "",
                }
            case STORAGE_DESTINATION.BossCloudMedia:
                return {
                    accessKeyId: props?.item?.StorageCredentials?.BossCloudMedia?.accessKeyId ?? "",
                    secretAccessKey: props?.item?.StorageCredentials?.BossCloudMedia?.secretAccessKey ?? "",
                    imageBucketName: props?.item?.StorageCredentials?.BossCloudMedia?.imageBucketName ?? "",
                    videoBucketName: props?.item?.StorageCredentials?.BossCloudMedia?.videoBucketName ?? "",
                    api_key: props?.item?.StorageCredentials?.BossCloudMedia?.api_key ?? "",
                    imageCdnUrl: props?.item?.StorageCredentials?.BossCloudMedia?.imageCdnUrl ?? "",
                    videoCdnUrl: props?.item?.StorageCredentials?.BossCloudMedia?.videoCdnUrl ?? "",
                }
            case STORAGE_DESTINATION.Aspera:
                return {
                    host: props?.item?.StorageCredentials?.Aspera?.host ?? '',
                    username: props?.item?.StorageCredentials?.Aspera?.username ?? '',
                    privateKeyPath: props?.item?.StorageCredentials?.Aspera?.privateKeyPath ?? '',
                    remotePath: props?.item?.StorageCredentials?.Aspera?.remotePath ?? '',
                    port: props?.item?.StorageCredentials?.Aspera?.port ?? '',
                    bandwidth: props?.item?.StorageCredentials?.Aspera?.bandwidth ?? '',
                }
            case STORAGE_DESTINATION.SFTP:
                return {
                    host: props?.item?.StorageCredentials?.SFTP?.host ?? '',
                    username: props?.item?.StorageCredentials?.SFTP?.username ?? '',
                    password: props?.item?.StorageCredentials?.SFTP?.password ?? '',
                    port: props?.item?.StorageCredentials?.SFTP?.port ?? '',
                    dstFilePath: props?.item?.StorageCredentials?.SFTP?.dstFilePath ?? '',
                }
            case STORAGE_DESTINATION.FTP:
                return {
                    host: props?.item?.StorageCredentials?.FTP?.host ?? '',
                    username: props?.item?.StorageCredentials?.FTP?.username ?? '',
                    password: props?.item?.StorageCredentials?.FTP?.password ?? '',
                    port: props?.item?.StorageCredentials?.FTP?.port ?? '',
                    dstFilePath: props?.item?.StorageCredentials?.FTP?.dstFilePath ?? '',
                }
            case STORAGE_DESTINATION.SharedDirectory:
                return {
                    dstFilePath: props?.item?.StorageCredentials?.SharedDirectory?.dstFilePath ?? '',
                }
            case STORAGE_DESTINATION.SMTP:
                return {
                    host: props?.item?.StorageCredentials?.SMTP?.host ?? '',
                    port: props?.item?.StorageCredentials?.SMTP?.port ?? '',
                    secure: props?.item?.StorageCredentials?.SMTP?.secure ?? false,
                    rejectUnauthorized: props?.item?.StorageCredentials?.SMTP?.rejectUnauthorized ?? false,
                    username: props?.item?.StorageCredentials?.SMTP?.user ?? '',
                    password: props?.item?.StorageCredentials?.SMTP?.pass ?? '',
                    senderEmail: props?.item?.StorageCredentials?.SMTP?.from ?? '',
                    toEmail: props?.item?.StorageCredentials?.SMTP?.to ?? '',
                    ccEmail: props?.item?.StorageCredentials?.SMTP?.cc ?? '',
                    subject: props?.item?.StorageCredentials?.SMTP?.subject ?? '',
                    body: props?.item?.StorageCredentials?.SMTP?.body ?? '',
                }
            default: return {}
        }
    }

    console.log(props)
    const blankDataItem = {
        ...props?.item,
        Name: props?.item.Name ?? "",
        File: props?.item.File ?? "",
        Quality: props?.item.Quality ?? "",
        ...getCredentialData(),
        StorageDestination: props?.item.StorageDestination ? { _id: props?.item.StorageDestination, Description: utility.getKeyByValue(STORAGE_DESTINATION, props?.item.StorageDestination) } : { _id: STORAGE_DESTINATION.Cloudinary, Description: utility.getKeyByValue(STORAGE_DESTINATION, STORAGE_DESTINATION.Cloudinary) },
        CdnUrl: props?.item?.StorageCredentials?.S3?.CdnUrl ?? "",
        KeepOrg: props?.item.KeepOrg ?? false,
        Archive: props?.item.Archive ?? false,
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [storageDestinations, setStorageDestinations] = useState([]);

    // calculate height or width in media screen
    const [isMobile, setIsMobile] = useState(false);

    const [suggestionsState, setSuggestionsState] = useState({
        isOpen: false,
        fieldName: "", // "subject" or "body"
        anchorEl: null
    });

    const suggestions = [
        { key: 'date', label: 'Current Date (e.g., DD/MM/YYYY)' },
        { key: 'time', label: 'Current Time (e.g., HH:mm:ss)' },
        { key: 'dateTime', label: 'Current Date & Time (e.g., DD/MM/YYYY HH:mm:ss)' },
        { key: 'reportName', label: 'Report File Name (without extension)' }
    ];

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (suggestionsState.isOpen && !e.target.closest('.subject-suggest-container')) {
                setSuggestionsState({ isOpen: false, fieldName: "", anchorEl: null });
            }
        };
        window.addEventListener('click', handleOutsideClick);
        return () => window.removeEventListener('click', handleOutsideClick);
    }, [suggestionsState.isOpen]);

    const onFieldTextChange = (e) => {
        const { name, value } = e.target;
        setDataItem(prev => ({ ...prev, [name]: value }));
        
        const selectionStart = e.target.selectionStart;
        const textBeforeCursor = value.slice(0, selectionStart);
        
        if (textBeforeCursor.endsWith('{')) {
            setSuggestionsState({
                isOpen: true,
                fieldName: name,
                anchorEl: e.currentTarget
            });
        } else {
            setSuggestionsState({
                isOpen: false,
                fieldName: "",
                anchorEl: null
            });
        }
    }

    const handleSelectSuggestion = (placeholder) => {
        const fieldName = suggestionsState.fieldName;
        const input = document.getElementsByName(fieldName)[0];
        if (!input) return;

        const value = dataItem[fieldName] || "";
        const selectionStart = input.selectionStart;
        const textBeforeCursor = value.slice(0, selectionStart);
        const textAfterCursor = value.slice(selectionStart);

        const lastCurlyBraceIndex = textBeforeCursor.lastIndexOf('{');
        if (lastCurlyBraceIndex !== -1) {
            const newValue = textBeforeCursor.slice(0, lastCurlyBraceIndex) + `{{${placeholder}}}` + textAfterCursor;
            setDataItem(prev => ({ ...prev, [fieldName]: newValue }));
            
            setTimeout(() => {
                input.focus();
                const newCursorPos = lastCurlyBraceIndex + placeholder.length + 4; // +4 for {{ and }}
                input.setSelectionRange(newCursorPos, newCursorPos);
            }, 0);
        }
        setSuggestionsState({ isOpen: false, fieldName: "", anchorEl: null });
    }

    useEffect(() => {
        // Function to calculate screen orientation and size
        const updateScreenType = () => {
            const isPortrait = window.innerHeight > window.innerWidth;
            setIsMobile(isPortrait); // Set true for portrait mode
        };

        // Initial check
        updateScreenType();

        // Add event listener for window resize
        window.addEventListener('resize', updateScreenType);

        if (utility.isAutomateB()) {
            // google analytics
            ReactGA.event({
                category: "Page View",
                action: "Dashboard Loaded",
                label: window.location.pathname,
            });
        }

        // Handle Key Shortcuts (Ctrl+S, Escape)
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                props.cancelEdit();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "s") {
                event.preventDefault(); // Prevent browser save
                handleSubmit();
            }
        };
        window.addEventListener('keydown', handleKeyDown);

        // Cleanup listener on unmount
        return () => {
            window.removeEventListener('resize', updateScreenType);
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []); // Note: handleSubmit dependency missing, but refs or safe closures usually preferred. For simplicity keeping empty mostly safe if state is current. Actually dataItem will be stale. 
    // Fixing stale closure issue for keyboard shortcut:
    // ... Actually to fix stale dataItem in handleSubmit, I should use a ref or depend on dataItem in useEffect.
    // For now standard approach:

    // Re-bind keydown when dataItem changes is expensive. 
    // Let's wrapping handleSubmit in a ref or let the user click the button mainly, 
    // but the shortcut is nice. I'll add dataItem to dep array for keydown effect.

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                props.cancelEdit();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "s") {
                event.preventDefault();
                handleSubmit();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [dataItem]); // Re-bind on data change


    useEffect(() => {
        loadCombo()
    }, [])

    const loadCombo = async () => {
        let storageDestinationRes = Object.keys(STORAGE_DESTINATION).filter((x) => {
            return x != "BossCloudMedia";
        }).map(x => {
            return {
                _id: STORAGE_DESTINATION[x],
                Description: x
            }
        })
        setStorageDestinations(storageDestinationRes)
    }

    const onChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (name === "Archive" || name === "KeepOrg" || name === "secure" || name === "rejectUnauthorized") {
            // For Checkboxes
            setDataItem(prev => ({ ...prev, [name]: checked }));
        } else {
            setDataItem(prev => ({ ...prev, [name]: value }));
        }
    }

    // Special handler for Storage Destination Select
    const onDestinationChange = (e) => {
        const selectedId = e.target.value;
        const selectedObj = storageDestinations.find(x => x._id === selectedId);
        if (selectedObj) {
            setDataItem(prev => ({ ...prev, StorageDestination: selectedObj }));
        }
    }


    const isValid = () => {
        if (!dataItem.Name) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        if (dataItem.Quality > 100) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.quality_should_be_less_than_100_error_message });
            return false
        }
        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.Cloudinary) {
            if (!dataItem.cloud_name) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_cloud_name_error_message }); return false; }
            if (!dataItem.api_key) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_api_key_error_message }); return false; }
            if (!dataItem.api_secret) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_api_secret_error_message }); return false; }
        }
        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.S3) {
            if (!dataItem.accessKeyId) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_access_keyid_error_message }); return false; }
            if (!dataItem.secretAccessKey) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_secret_access_key_error_message }); return false; }
            if (!dataItem.region) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_region_error_message }); return false; }
            if (!dataItem.bucketName) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_bucket_name_error_message }); return false; }
            if (!dataItem.CdnUrl) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_cdn_url_error_message }); return false; }
        }
        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.BossCloudMedia) {
            if (!dataItem.accessKeyId) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_access_keyid_error_message }); return false; }
            if (!dataItem.secretAccessKey) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_secret_access_key_error_message }); return false; }
            if (!dataItem.imageBucketName) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_image_bucket_name_error_message }); return false; }
            if (!dataItem.videoBucketName) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_video_bucket_name_error_message }); return false; }
            if (!dataItem.api_key) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_api_key_error_message }); return false; }
            if (!dataItem.imageCdnUrl) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_image_cdn_url_error_message }); return false; }
            if (!dataItem.videoCdnUrl) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_video_cdn_url_error_message }); return false; }
        }
        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.Aspera) {
            if (!dataItem.host) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter host' }); return false; }
            if (!dataItem.username) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter username' }); return false; }
            if (!dataItem.privateKeyPath) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter private key path' }); return false; }
            if (!dataItem.remotePath) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter remote path' }); return false; }
            if (!dataItem.port) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter port' }); return false; }
            if (!dataItem.bandwidth) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter bandwidth' }); return false; }
        }
        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.SFTP) {
            if (!dataItem.host) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter host' }); return false; }
            if (!dataItem.username) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter username' }); return false; }
            if (!dataItem.password) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter password' }); return false; }
            if (!dataItem.port) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter port' }); return false; }
            if (!dataItem.dstFilePath) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter destination file path' }); return false; }
        }
        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.FTP) {
            if (!dataItem.host) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter host' }); return false; }
            if (!dataItem.username) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter user' }); return false; }
            if (!dataItem.password) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter password' }); return false; }
            if (!dataItem.port) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter port' }); return false; }
            if (!dataItem.dstFilePath) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter destination file path' }); return false; }
        }
        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.SharedDirectory) {
            if (!dataItem.dstFilePath) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter destination file path' }); return false; }
        }
        const validateEmails = (emailsString) => {
            if (!emailsString) return true;
            const emails = emailsString.split(',').map(e => e.trim());
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emails.every(email => emailRegex.test(email));
        }

        if (dataItem.StorageDestination._id == STORAGE_DESTINATION.SMTP) {
            if (!dataItem.host) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter SMTP host' }); return false; }
            if (!dataItem.port) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter SMTP port' }); return false; }
            if (!dataItem.username) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter SMTP username' }); return false; }
            if (!dataItem.password) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter SMTP password' }); return false; }
            if (!dataItem.senderEmail) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter sender email' }); return false; }
            if (!dataItem.toEmail) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter recipient email' }); return false; }
            if (!dataItem.subject) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter SMTP subject template' }); return false; }
            if (!dataItem.body) { ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter SMTP body template' }); return false; }

            if (!validateEmails(dataItem.toEmail)) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter valid recipient email address(es)' });
                return false;
            }
            if (dataItem.ccEmail && !validateEmails(dataItem.ccEmail)) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please enter valid CC email address(es)' });
                return false;
            }
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        let finalData = {
            _id: dataItem._id,
            SID: dataItem.SID ?? 0,
            Name: dataItem.Name,
            File: dataItem.File,
            Quality: dataItem.Quality,
            StorageDestination: dataItem.StorageDestination._id,
            StorageCredentials: getStorageDestinationCredentials(),
            KeepOrg: dataItem.KeepOrg ?? false,
            Archive: dataItem.Archive ?? false,
        }

        console.log(finalData);

        let res = await API.saveData(ENTITYNAME.PublishProvider, finalData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.PUBLISH_PROVIDER, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.PublishProvider);
            props.cancelEdit();
            props.refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const getStorageDestinationCredentials = () => {
        switch (dataItem.StorageDestination._id) {
            case STORAGE_DESTINATION.Cloudinary:
                return {
                    Cloudinary: {
                        cloud_name: dataItem.cloud_name,
                        api_key: dataItem.api_key,
                        api_secret: dataItem.api_secret,
                        preset: dataItem.preset
                    }
                }
            case STORAGE_DESTINATION.S3:
                return {
                    S3: {
                        accessKeyId: dataItem.accessKeyId,
                        secretAccessKey: dataItem.secretAccessKey,
                        region: dataItem.region,
                        bucketName: dataItem.bucketName,
                        CdnUrl: dataItem.CdnUrl,
                    }
                }
            case STORAGE_DESTINATION.BossCloudMedia:
                return {
                    BossCloudMedia: {
                        accessKeyId: dataItem.accessKeyId,
                        secretAccessKey: dataItem.secretAccessKey,
                        imageBucketName: dataItem.imageBucketName,
                        videoBucketName: dataItem.videoBucketName,
                        api_key: dataItem.api_key,
                        imageCdnUrl: dataItem.imageCdnUrl,
                        videoCdnUrl: dataItem.videoCdnUrl
                    }
                }
            case STORAGE_DESTINATION.Aspera:
                return {
                    Aspera: {
                        host: dataItem.host,
                        username: dataItem.username,
                        privateKeyPath: dataItem.privateKeyPath,
                        remotePath: dataItem.remotePath,
                        port: dataItem.port,
                        bandwidth: dataItem.bandwidth
                    }
                }
            case STORAGE_DESTINATION.SFTP:
                return {
                    SFTP: {
                        host: dataItem.host,
                        username: dataItem.username,
                        password: dataItem.password,
                        port: dataItem.port,
                        dstFilePath: dataItem.dstFilePath
                    }
                }
            case STORAGE_DESTINATION.FTP:
                return {
                    FTP: {
                        host: dataItem.host,
                        user: dataItem.username,
                        password: dataItem.password,
                        port: dataItem.port,
                        dstFilePath: dataItem.dstFilePath
                    }
                }
            case STORAGE_DESTINATION.SharedDirectory:
                return {
                    SharedDirectory: {
                        dstFilePath: dataItem.dstFilePath
                    }
                }
            case STORAGE_DESTINATION.SMTP:
                return {
                    SMTP: {
                        host: dataItem.host,
                        port: dataItem.port,
                        secure: dataItem.secure,
                        rejectUnauthorized: dataItem.rejectUnauthorized,
                        user: dataItem.username,
                        pass: dataItem.password,
                        from: dataItem.senderEmail,
                        to: dataItem.toEmail,
                        cc: dataItem.ccEmail,
                        subject: dataItem.subject,
                        body: dataItem.body
                    }
                }
            default:
                return {};
        }
    }

    // Common styles for inputs
    const inputStyle = {
        '& .MuiOutlinedInput-root': {
            minHeight: '48px',
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
        },
    };

    const getIconForDestination = (id) => {
        switch (id) {
            case STORAGE_DESTINATION.Cloudinary: return <CloudIcon sx={{ mr: 1, color: '#3448c5' }} />;
            case STORAGE_DESTINATION.S3: return <CloudIcon sx={{ mr: 1, color: '#FF9900' }} />;
            case STORAGE_DESTINATION.Download: return <CloudDownloadIcon sx={{ mr: 1, color: '#4caf50' }} />;
            case STORAGE_DESTINATION.SharedDirectory: return <FolderSharedIcon sx={{ mr: 1, color: '#9c27b0' }} />;
            case STORAGE_DESTINATION.SFTP:
            case STORAGE_DESTINATION.FTP: return <ShuffleIcon sx={{ mr: 1, color: '#00bcd4' }} />;
            case STORAGE_DESTINATION.Aspera: return <DnsIcon sx={{ mr: 1, color: '#ff5722' }} />;
            case STORAGE_DESTINATION.SMTP: return <MailIcon sx={{ mr: 1, color: '#e91e63' }} />;
            default: return <StorageIcon sx={{ mr: 1, color: '#607d8b' }} />;
        }
    }

    return (
        <BossDialog
            title={props?.item?.name ? props?.item?.name : lang.create_storage_provider_header}
            onClose={props.cancelEdit}
            width={"50%"}
        >

            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />

            <Box sx={{ p: 0, mt: 2 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={lang.name_label}
                            name="Name"
                            value={dataItem.Name}
                            onChange={onChange}
                            required
                            sx={inputStyle}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth sx={inputStyle}>
                            <InputLabel id="storage-dest-label">{lang.storage_destination_label}</InputLabel>
                            <Select
                                labelId="storage-dest-label"
                                value={dataItem.StorageDestination._id || ""}
                                label={lang.storage_destination_label}
                                onChange={onDestinationChange}
                                sx={{ minHeight: '48px' }}
                                renderValue={(selected) => {
                                    const found = storageDestinations.find(x => x._id === selected);
                                    return (
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {getIconForDestination(selected)}
                                            {found ? found.Description : selected}
                                        </Box>
                                    );
                                }}
                            >
                                {storageDestinations.map((dest) => (
                                    <MenuItem key={dest._id} value={dest._id}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {getIconForDestination(dest._id)}
                                            {dest.Description}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Aspera Fields */}
                    {dataItem.StorageDestination._id == STORAGE_DESTINATION.Aspera && (
                        <>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Host" name="host" value={dataItem.host} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Username" name="username" value={dataItem.username} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Private Key Path" name="privateKeyPath" value={dataItem.privateKeyPath} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Remote Path" name="remotePath" value={dataItem.remotePath} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Port" name="port" value={dataItem.port} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Bandwidth" name="bandwidth" value={dataItem.bandwidth} onChange={onChange} />
                            </Grid>
                        </>
                    )}

                    {/* SharedDirectory Fields */}
                    {dataItem.StorageDestination._id == STORAGE_DESTINATION.SharedDirectory && (
                        <Grid item xs={12}>
                            <TextField fullWidth sx={inputStyle} label="Destination Filepath" name="dstFilePath" value={dataItem.dstFilePath} onChange={onChange} required />
                        </Grid>
                    )}

                    {/* SMTP / Email Fields */}
                    {dataItem.StorageDestination._id == STORAGE_DESTINATION.SMTP && (
                        <>
                            <Grid item xs={6}>
                                <TextField fullWidth sx={inputStyle} label="SMTP Host" name="host" value={dataItem.host} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField fullWidth sx={inputStyle} label="SMTP Port" name="port" value={dataItem.port} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField fullWidth sx={inputStyle} label="Sender Email" name="senderEmail" value={dataItem.senderEmail} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth sx={inputStyle} label="SMTP Username" name="username" value={dataItem.username} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth sx={inputStyle} label="SMTP Password" type="password" name="password" value={dataItem.password} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    sx={inputStyle}
                                    label="Recipient Email(s)"
                                    name="toEmail"
                                    value={dataItem.toEmail || ""}
                                    onChange={onChange}
                                    required
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <InfoRoundButton message="Enter multiple recipient email addresses separated by commas (e.g. user1@example.com, user2@example.com)" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    sx={inputStyle}
                                    label="Cc Email(s)"
                                    name="ccEmail"
                                    value={dataItem.ccEmail || ""}
                                    onChange={onChange}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <InfoRoundButton message="Enter multiple CC email addresses separated by commas (e.g. user1@example.com, user2@example.com)" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div className="subject-suggest-container" style={{ position: 'relative' }}>
                                    <TextField
                                        fullWidth
                                        sx={inputStyle}
                                        label="Subject"
                                        name="subject"
                                        value={dataItem.subject || ""}
                                        onChange={onFieldTextChange}
                                        required
                                        placeholder="e.g. Publish Report for {{date}} (Type '{' for placeholders)"
                                        helperText="Type '{' to insert dynamic placeholders like {{date}}, {{time}}, {{dateTime}}, or {{reportName}}"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div className="subject-suggest-container" style={{ position: 'relative' }}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={4}
                                        sx={inputStyle}
                                        label="Email Body"
                                        name="body"
                                        value={dataItem.body || ""}
                                        onChange={onFieldTextChange}
                                        required
                                        placeholder="e.g. Hi Team, Please find attached the report for {{date}} (Type '{' for placeholders)"
                                        helperText="Type '{' to insert dynamic placeholders like {{date}}, {{time}}, {{dateTime}}, or {{reportName}}"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControlLabel
                                    control={<Checkbox checked={dataItem.secure || false} onChange={onChange} name="secure" />}
                                    label="Secure (SSL/TLS)"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControlLabel
                                    control={<Checkbox checked={dataItem.rejectUnauthorized || false} onChange={onChange} name="rejectUnauthorized" />}
                                    label="Reject Unauthorized (SSL Cert Verification)"
                                />
                            </Grid>

                            <Popper
                                open={suggestionsState.isOpen}
                                anchorEl={suggestionsState.anchorEl}
                                placement="bottom-start"
                                style={{
                                    zIndex: 999999,
                                    width: suggestionsState.anchorEl ? suggestionsState.anchorEl.clientWidth : 'auto'
                                }}
                            >
                                <Paper
                                    elevation={4}
                                    sx={{
                                        border: '1px solid rgba(0, 0, 0, 0.15)',
                                        maxHeight: '220px',
                                        overflowY: 'auto',
                                        background: '#ffffff',
                                        mt: 0.5
                                    }}
                                >
                                    {suggestions.map((s) => (
                                        <MenuItem
                                            key={s.key}
                                            onClick={() => handleSelectSuggestion(s.key)}
                                            sx={{
                                                py: 1.5,
                                                px: 2,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                                borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                                                '&:last-child': { borderBottom: 'none' }
                                            }}
                                        >
                                            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#3448c5' }}>
                                                {"{{"}{s.key}{"}}"}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.2 }}>
                                                {s.label}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </Paper>
                            </Popper>
                        </>
                    )}

                    {/* Cloudinary Fields */}
                    {dataItem.StorageDestination._id == STORAGE_DESTINATION.Cloudinary && (
                        <>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.cloud_name_label} name="cloud_name" value={dataItem.cloud_name} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.api_key_label} name="api_key" value={dataItem.api_key} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.api_secret_label} name="api_secret" value={dataItem.api_secret} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.preset_label} name="preset" value={dataItem.preset} onChange={onChange} />
                            </Grid>
                        </>
                    )}

                    {/* FTP/SFTP Fields */}
                    {(dataItem.StorageDestination._id == STORAGE_DESTINATION.SFTP || dataItem.StorageDestination._id == STORAGE_DESTINATION.FTP) && (
                        <>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Host" name="host" value={dataItem.host} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Username" name="username" value={dataItem.username} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Password" type="password" name="password" value={dataItem.password} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Port" name="port" value={dataItem.port} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label="Destination Filepath" name="dstFilePath" value={dataItem.dstFilePath} onChange={onChange} required />
                            </Grid>
                        </>
                    )}

                    {/* S3 Fields */}
                    {dataItem.StorageDestination._id == STORAGE_DESTINATION.S3 && (
                        <>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.access_key_id_label} name="accessKeyId" value={dataItem.accessKeyId} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.secret_access_key_label} name="secretAccessKey" value={dataItem.secretAccessKey} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.region_label} name="region" value={dataItem.region} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.bucket_name_label} name="bucketName" value={dataItem.bucketName} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={8}>
                                <TextField fullWidth sx={inputStyle} label={lang.cdn_url_label} name="CdnUrl" value={dataItem.CdnUrl} onChange={onChange} required />
                            </Grid>
                        </>
                    )}

                    {/* BossCloudMedia Fields */}
                    {dataItem.StorageDestination._id == STORAGE_DESTINATION.BossCloudMedia && (
                        <>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.base_api_key_label} name="api_key" value={dataItem.api_key} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.s3_access_key_id_label} name="accessKeyId" value={dataItem.accessKeyId} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField fullWidth sx={inputStyle} label={lang.s3_secret_access_key_label} name="secretAccessKey" value={dataItem.secretAccessKey} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth sx={inputStyle} label={lang.s3_image_bucket_name_label} name="imageBucketName" value={dataItem.imageBucketName} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth sx={inputStyle} label={lang.s3_video_bucket_name_label} name="videoBucketName" value={dataItem.videoBucketName} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth sx={inputStyle} label={lang.s3_image_cdn_url_label} name="imageCdnUrl" value={dataItem.imageCdnUrl} onChange={onChange} required />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth sx={inputStyle} label={lang.s3_video_cdn_url_label} name="videoCdnUrl" value={dataItem.videoCdnUrl} onChange={onChange} required />
                            </Grid>
                        </>
                    )}

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox checked={dataItem.Archive} onChange={onChange} name="Archive" />}
                            label={lang.archive}
                        />
                    </Grid>
                </Grid>
            </Box>
        </BossDialog>
    )
}
export default PublishProviderEditForm;